module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/fonts/plantin_regular-482a9d7971e8a1016835b4e76bba458f.woff";